import { AfterViewInit, Component, ElementRef, OnInit, inject, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { DialogBaseComponent } from '../../../shared/dialogs/dialog-base.component';
import { UpdateGroup } from '../../services/group.service';

@Component({
  selector: 'app-rename-group-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './rename-group-dialog.component.html',
  styleUrl: './rename-group-dialog.component.scss'
})
export class RenameGroupDialogComponent extends DialogBaseComponent implements OnInit, AfterViewInit {
  nameInput = viewChild.required('nameInput', { read: ElementRef });

  private formBuilder = inject(FormBuilder);
  form = this.formBuilder.group({
    name: ['', Validators.required],
    description: ['']
  });

  ngOnInit(): void {
    this.form.patchValue({
      name: this.options.name,
      description: this.options.description
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.nameInput().nativeElement.focus();
    });
  }

  onRenameGroup() {
    const updateGroup: UpdateGroup = {
      groupId: this.options.groupId,
      name: this.form.value.name!,
      description: this.form.value.description ?? '',
      institutions: []
    }
    this.complete(updateGroup);
  }
}
